import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { StringKeyDictionary } from "../commonInterfaces";
import { AdditionalData, Entity } from "../core/components/commonApp";
import {
    EditableGrid,
    EditableGridProps,
    field,
    InGridButtonClickParams,
    InGridToolBarButton,
    Schema
} from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Currency } from "../generalSettings/commercial/dialogs/currencyDialog";
import { EntityServiceReport } from "./serviceReport";
import { openStockSearch } from "../stock/openStockSearch";
import { Warehouse } from "../stock/stocks";
import { Config } from "../core/config/config";
import React from "react";

export class ServiceReportMaterialsInGrid extends React.Component<ServiceReportMaterialsGridProps, ServiceReportMaterialsGridState>{
    translations: StringKeyDictionary<string> = null;
    editableGridRef: EditableGrid;
    private warehouseActive = Config.settings.warehouseActive;
    private gridOptions;
    constructor(props: any) {
        super(props)
        this.state = {
            Currencies: [],
            Warehouses: []
        };
        this.translations = this.props.translations;
        this.initApp();
    }

    private initApp = async () => {
        this.gridOptions = JSON.parse(JSON.stringify(this.props.gridOptions));
        if (!this.warehouseActive)
            this.gridOptions.columns = this.gridOptions.columns.filter(col => col.field != "warehouseMC")
        await Promise.all([
            this.getCurrencies(),
            this.getWarehouses()
        ]);
    }

    private getCurrencies = async () => {
        let result = await HTTPService.get<JsonResultClass<Currency[]>>("ServiceReport/GetCurrencies");
        this.setState({ Currencies: result.Data });
    }

    private getWarehouses = async () => {
        const data = await HTTPService.get("Stock/GetWarehouses");
        this.setState({ Warehouses: data })
    }

    private getCurrency = (idCurr: number): Currency => {
        let currency = this.props.entity.DefaultCurrency;
        if (idCurr > 0) {
            let currencyName = this.state.Currencies.find(x => x.Id == idCurr)?.Currency;
            if (Helper.hasValue(currencyName)) {
                let convertCurrency = this.props.entity.ConvertToTargetCurrencies.find(x => x.Currency == currencyName);
                currency = convertCurrency;
            }
        }
        return currency;
    }

    private setWarehouse = (dataItem) => {
        const warehouse = this.state.Warehouses.find(f => f.Id == dataItem.WarehouseId);
        if (warehouse) {
            dataItem.Warehouse = warehouse.Name;
            //dataItem.set("Warehouse", warehouse.Name)
            const storageSpace = warehouse.StorageSpaces.find(f => f.Id == dataItem.StorageSpaceId);
            if (storageSpace) {
                dataItem.StorageSpace = storageSpace.Name
                //dataItem.set("StorageSpace", storageSpace.Name)
            }
        }
    }

    private getMachineAdditionalData = async (maschNr: string): Promise<AdditionalData> => {
        let result = await HTTPService.get<AdditionalData>("MachineLookUp/GetMachineAdditionalData", { id: maschNr });
        return result;
    }

    private setGpreis(dataItem: EntityServiceReportMaterial, changedDataItem) {
        let sum = this.getPrice(dataItem.Anzahl, dataItem.Epreis, dataItem.Rabatt ?? 0, dataItem.Faktor);
        changedDataItem.set("Gpreis", sum);
    }

    private getPrice(anzahl: number, epreis: number, rabatt: number, faktor: number): number {
        if (Helper.hasValue(anzahl) && Helper.hasValue(epreis) && Helper.hasValue(rabatt) && Helper.hasValue(faktor)) {
            let sum = anzahl * epreis * (1 - (rabatt / 100)) / faktor;
            return parseFloat(sum.toFixed(2));
        }
        return null;
    }

    private resolveAdditionalData = async (newValue: any, fieldName: string, fullObject: any, options: any) => {
        switch (fieldName) {
            case "Artikelnr":
                let currency = this.getCurrency(fullObject?.idcurr);
                if (!Helper.hasValue(currency)) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.GeneralSettings.Currency.MainGroupCurrencies.ConNotConvert"));
                    return null;
                }

                let faktor = currency.Factor ?? 1;
                options.model.set("Currency", currency.Currency);
                options.model.set("CurrencySymbol", currency.Characters);
                options.model.set("Faktor", faktor);
                options.model.set("Artikelnummer", fullObject?.artikelnummer ?? "");
                options.model.set("Seriennr", fullObject?.seriennr ?? "");
                options.model.set("Chargennr", fullObject?.chargennr ?? "");
                options.model.set("Produkt", fullObject?.produkt ?? "");
                options.model.set("Epreis", fullObject?.preis ?? 0);
                options.model.set("Kosten", fullObject?.ekpreis ?? 0);
                options.model.set("Einheit", fullObject?.einheit ?? "");
                options.model.set("Anzahl", 1);
                options.model.set("Gpreis", this.getPrice(1, fullObject?.preis ?? 0, 0, faktor));
                let artAdditionalData: AdditionalData = { Description: fullObject?.bezeichnung ?? "" }
                return artAdditionalData;
            case "Maschnr":
                let maschineView = await this.getMachineAdditionalData(newValue);
                return maschineView;
            case "Kls":
                let klsAdditionalData: AdditionalData = { Description: fullObject.verursacher };
                return klsAdditionalData;
        }
    }

    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.handleItemChanged(fieldName, dataItems);
            this.flag = false;
        }
        else if (action == "add") {
        }
        else if (action == "remove") {

        }
        this.props.onChange();
    }

    private async handleItemChanged(fieldName: string, dataItems) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        let dataItem: EntityServiceReportMaterial = changedDataItem;
        switch (fieldName) {
            case "Datum":
                changedDataItem.set("WeekDay", kendo.toString(kendo.parseDate(changedDataItem.Datum), "ddd"));
                break;
            case "Anzahl":
            case "Epreis":
            case "Rabatt":
                this.setGpreis(dataItem, changedDataItem);
                break;
        }
        if (this.props.entity.RueckreiseModusActivated)
            changedDataItem.set("ErfasstNachSignatur", true);
        changedDataItem.set("Changed", true);
    }

    private createNewEntity(): EntityServiceReportMaterial {
        let newEntry: EntityServiceReportMaterial = {
            IsNew: true,
            Isguid: "{" + kendo.guid() + "}",
            Changed: true,
            IndividualFields: {},
            RecordRight: this.props.entity.RecordRight,
            IsWatchable: this.props.entity.IsWatchable,
            IsWatched: this.props.entity.IsWatched,
            Rabatt: 0,
            Seriennr: '',
            Chargennr: '',
            Artikelnummer: '',
            CreateLogin: '',
            ChangeLogin: ''
        }
        return newEntry;
    }

    private calcNewValues(dataSource: kendo.data.DataSource, newEntry: EntityServiceReportMaterial) {
        let entries = (dataSource.data() as any) as EntityServiceReportMaterial[];
        let destroyedData = dataSource["destroyed"]();

        let newDate = kendo.parseDate(this.props.entity.Dvon);
        let newPos = 1;

        if (entries.length >= 1) {
            newDate = entries.filter(x => Helper.hasValue(x.Datum)).reduce((prev, current) => (prev.Datum > current.Datum) ? prev : current).Datum;
            newPos = entries.filter(x => Helper.hasValue(x.Pos)).reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
        }
        if (destroyedData.length >= 1) {
            let destroyedMaxPos = destroyedData.filter(x => Helper.hasValue(x.Pos)).reduce((prev, current) => (prev.Pos > current.Pos) ? prev : current).Pos + 1;
            if (destroyedMaxPos > newPos)
                newPos = destroyedMaxPos;
        }

        newEntry.Datum = newDate;
        newEntry.WeekDay = kendo.toString(newDate, "ddd");
        newEntry.Pos = newPos;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    addMaterialFromProjectOrDelegation = (p: InGridButtonClickParams, searchName: string, refField: string) => {
        const url = "DynamicSearch/Window/" + searchName + "?multi=true&displayPattern=[[artikelnummer]]&cus_BelegNr=" + this.props.entity.Belegnr + "&cus_ProjNr=" + this.props.entity.Projnr + "&cus_PIndex=" + this.props.entity.Pindex;
        const sheet = General.Sheet.Manager.createSheetWithUrl(encodeURI(url), null, { disableTabTitle: true });
        sheet.bind(SheetEventType.ItemsSelected, (data) => {
            for (let i = 0; i < data.data.length; i++) {
                if (Helper.findIndex(this.props.entity.Materials, refField, data.data[i].pos) == -1) {
                    let newMaterial = this.createNewMaterialFromSearchRow(p, data.data[i], searchName);
                    if (Helper.hasValue(newMaterial))
                        p.actions.add(newMaterial);
                }
            }
        });
    }

    createNewMaterialFromSearchRow = (p: InGridButtonClickParams, dataItem: { artnr: any; bezeichnung: any; artikelnummer: any; seriennr: any; chargennr: any; produkt: any; anzahl: any; epreis: any; kosten: any; maschnr: any; bemerkung: any; rechnungstext: any; einheit: any; rabatt: any; pos: number; kmpos: number; idcurr: number; maschbezeichnung: any; }, searchName: string) => {
        let materialEntity: EntityServiceReportMaterial = {
            IsNew: true,
            IsWatchable: false,
            IsWatched: false,
            Changed: true,
            Isguid: "{" + kendo.guid() + "}",
            RecordRight: { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite },
            IndividualFields: {},
            Artikelnr: dataItem.artnr,
            Artikelnr_additional_data: { Description: dataItem.bezeichnung },
            Artikelnummer: dataItem.artikelnummer,
            Seriennr: dataItem.seriennr,
            Chargennr: dataItem.chargennr,
            Produkt: dataItem.produkt,
            Anzahl: dataItem.anzahl,
            Epreis: dataItem.epreis,
            Kosten: dataItem.kosten,
            Maschnr: dataItem.maschnr,
            Bemerkung: dataItem.bemerkung,
            Rechnungstext: dataItem.rechnungstext,
            Einheit: dataItem.einheit,
            Rabatt: dataItem.rabatt ?? 0
        };

        if (searchName == "article_servicereport_project") {
            materialEntity.KmPos = dataItem.pos;
        } else if (searchName == "article_servicereport_assignment") {
            materialEntity.KmPos = dataItem.kmpos;
            materialEntity.PlmPos = dataItem.pos;
        }

        let currency = this.getCurrency(dataItem.idcurr);
        if (!Helper.hasValue(currency)) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.GeneralSettings.Currency.MainGroupCurrencies.ConNotConvert"));
            return null;
        }
        materialEntity.Currency = currency.Currency;
        materialEntity.Faktor = currency.Factor;
        materialEntity.CurrencySymbol = currency.Characters;
        materialEntity.Gpreis = this.getPrice(materialEntity.Anzahl, materialEntity.Epreis, materialEntity.Rabatt ?? 0, materialEntity.Faktor);

        if (Helper.hasValue(dataItem.maschbezeichnung))
            materialEntity.Maschnr_additional_data = { Description: dataItem.maschbezeichnung };
        this.calcNewValues(p.dataSource, materialEntity);
        return materialEntity;
    }

    private getFromWarehouse = async (p: InGridButtonClickParams) => {
        const rawData = await openStockSearch();
        const data = rawData.map((item) => {
            const entity: EntityServiceReportMaterial = {
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                Changed: true,
                Isguid: "{" + kendo.guid() + "}",
                RecordRight: { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite },
                IndividualFields: {},
                Artikelnr: item.artNr,
                Artikelnr_additional_data: { Description: item.article.article },
                Artikelnummer: item.article.articlenumber,
                Seriennr: item.serienNr,
                Chargennr: item.chargenNr,
                Produkt: item.article,
                Anzahl: item.amount,
                Epreis: item.article.ekpreis ?? 0,
                Kosten: item.article.preis ?? 0,
                Maschnr: null,
                Bemerkung: null,
                Rechnungstext: null,
                Einheit: null,
                Rabatt: 0,

                WarehouseId: item.lagerId,
                StorageSpaceId: item.lagerplatzId
            }
            this.setWarehouse(entity);
            const currency = this.getCurrency(item.article.idcurr);
            if (!Helper.hasValue(currency)) {
                NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.GeneralSettings.Currency.MainGroupCurrencies.ConNotConvert"));
                return null;
            }

            entity.Currency = currency.Currency;
            entity.Faktor = currency.Factor;
            entity.CurrencySymbol = currency.Characters;
            entity.Gpreis = this.getPrice(entity.Anzahl, entity.Epreis, 0, entity.Faktor);

            this.calcNewValues(p.dataSource, entity);

            return entity;
        })

        p.actions.addBulk(data)

    }

    private resetWarehouse = (p: InGridButtonClickParams) => {
        const entity = p.selectedItems[0];
        const { Anzahl, Artikelnr, Chargennr, Seriennr } = entity;

        const url = `DynamicSearch/Window/Stock?fullObject=true&cus_amount=${Anzahl}&cus_artnr=${Artikelnr}&cus_chargennr=${Chargennr}&cus_seriennr=${Seriennr}`
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.RowClicked, (data) => {
            const { warehouseid, storagespaceid } = data;
            entity.WarehouseId = warehouseid;
            //entity.set("WarehouseId", warehouseid);
            entity.StorageSpaceId = storagespaceid;
            //entity.set("StorageSpaceId", storagespaceid)
            entity.Changed = true;
            this.setWarehouse(entity);
            const index = this.props.data.findIndex(f => f.Pos == entity.Pos);
            const lst = JSON.parse(JSON.stringify(this.props.data))
            lst[index] = entity;
            Helper.updateEntity(this.props.data, lst)
            this.setState({}, () => {
                this.editableGridRef.updateDataDirty();
                this.props.onChange();
            })
        })
    }


    handleButtonClick = async (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                const newItem: EntityServiceReportMaterial = this.createNewEntity();
                this.calcNewValues(p.dataSource, newItem);
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
            case "addMaterial":
                this.addMaterialFromProjectOrDelegation(p, "article_servicereport_all", "Kmpos");
                break;
            case "addMaterialFromProject":
                this.addMaterialFromProjectOrDelegation(p, "article_servicereport_project", "Kmpos");
                break;
            case "addMaterialFromDelegation":
                this.addMaterialFromProjectOrDelegation(p, "article_servicereport_assignment", "Plmpos");
                break;
            case "getFromWarehouse":
                this.getFromWarehouse(p)
                break;
            case "setWarehouse":
                this.resetWarehouse(p)
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite && !this.props.entity.RecordRight.IsRueckModusAdded && !this.props.entity.RecordRight.IsRueckModusReadOnly;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "addMaterial",
            iconClass: "k-i-seek-s",
            caption: Helper.getTranslation("Standard.Add")
        })
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "addMaterialFromProject",
            iconClass: "k-i-seek-s",
            caption: Helper.getTranslation("WebSMS.ServiceReport.MaterialAusProjektHinzufügen")
        })
        buttons.push({
            type: ToolBarInGridButtonType.CUSTOM,
            id: "addMaterialFromDelegation",
            iconClass: "k-i-seek-s",
            caption: Helper.getTranslation("WebSMS.ServiceReport.MaterialAusEinsatzHinzufügen")
        })

        if (this.warehouseActive) {
            buttons.push({
                type: ToolBarInGridButtonType.CUSTOM,
                id: "getFromWarehouse",
                iconClass: "fa-light fa-warehouse",
                caption: "Im Lagerbestand suchen"
            });

            buttons.push({
                type: ToolBarInGridButtonType.CUSTOM,
                id: "setWarehouse",
                iconClass: "fa-light fa-warehouse",
                caption: "Lager bestimmen",
                enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection
            });
        }
        

        let schema = new Schema();
        schema.Id = "Pos";
        schema.fields["Pos"] = new field("number");
        return <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <EditableGrid 
                editable={editable}
                data={this.props.data}
                schema={schema}
                resolveAdditionalData={this.resolveAdditionalData}
                onDataChanged={this.onGridDataChanged}
                ref={(ref) => this.editableGridRef = ref}
                buttons={buttons}
                onButtonClick={this.handleButtonClick}
                {...this.props}
                gridOptions={this.gridOptions}
                id="srMaterial"
            />
        </div>
    }
}

export interface ServiceReportMaterialsGridProps extends EditableGridProps{
    entity: EntityServiceReport;
    data: EntityServiceReportMaterial[];
    gridOptions: any;
    dataSources: any;
    translations: StringKeyDictionary<string>;
    onChange?: () => void;
}

export interface ServiceReportMaterialsGridState {
    Currencies: Currency[];
    Warehouses: Warehouse[];
}

export interface EntityServiceReportMaterial extends Entity {
    Datum?: Date;
    WeekDay?: string;
    Pos?: number;
    Maschnr?: string;
    Maschnr_additional_data?: AdditionalData;
    Bemerkung?: string;
    Rechnungstext?: string;
    Adrnr?: string;
    Email?: string;
    Fullname?: string;
    Kls?: string;
    Kls_additional_data?: AdditionalData;
    Isguid?: string;
    Changed?: boolean;

    Artikelnr?: number;
    Artikelnr_additional_data?: AdditionalData;
    Seriennr?: string;
    Chargennr?: string;
    Artikelnummer?: string;
    Produkt?: string;
    Einheit?: string;
    Epreis?: number;
    Kosten?: number;
    Gpreis?: number;
    Anzahl?: number;
    Rabatt?: number;
    Faktor?: number;
    Currency?: string;
    CurrencySymbol?: string;
    KmPos?: number;
    PlmPos?: number;

    BelegNr?: number;
    ProjNr?: string;
    PIndex?: number;
    CreateLogin?: string;
    CreateDate?: Date;
    ChangeLogin?: string;
    ChangeDate?: Date;

    WarehouseId?: number;
    Warehouse?: string;
    StorageSpaceId?: number;
    StorageSpace?: string;
}